import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setMobileMenuOpen(false);
    }
  };
  return <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50" data-id="element-119">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="flex justify-between items-center h-16" data-id="element-121">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => scrollToSection('hero')} data-id="element-122">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-123">
              <circle cx="20" cy="20" r="18" fill="#4ADE80" data-id="element-124" />
              <ellipse cx="15" cy="18" rx="2" ry="3" fill="#1F2937" data-id="element-125" />
              <ellipse cx="25" cy="18" rx="2" ry="3" fill="#1F2937" data-id="element-126" />
              <path d="M 12 25 Q 20 28 28 25" stroke="#1F2937" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-127" />
              <path d="M 8 12 L 12 8 L 14 12 Z" fill="#8B5CF6" data-id="element-128" />
              <path d="M 32 12 L 28 8 L 26 12 Z" fill="#8B5CF6" data-id="element-129" />
            </svg>
            <span className="text-2xl font-bold text-gray-900" data-id="element-130">Goblincamp</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8" data-id="element-131">
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-purple-600 font-medium transition-colors" data-id="element-132">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-purple-600 font-medium transition-colors" data-id="element-133">
              Services
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-gray-700 hover:text-purple-600 font-medium transition-colors" data-id="element-134">
              How It Works
            </button>
            <button onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-purple-600 font-medium transition-colors" data-id="element-135">
              Pricing
            </button>
            <button onClick={() => scrollToSection('team')} className="text-gray-700 hover:text-purple-600 font-medium transition-colors" data-id="element-136">
              Team
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-purple-600 font-medium transition-colors" data-id="element-137">
              Contact
            </button>
            <button onClick={() => scrollToSection('cta')} className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-2 rounded-full font-semibold hover:shadow-lg transition-all" data-id="element-138">
              Get Started
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-gray-700" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-139">
            {mobileMenuOpen ? <X size={24} data-id="element-140" /> : <Menu size={24} data-id="element-141" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="md:hidden py-4 space-y-3" data-id="element-142">
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-gray-700 hover:text-purple-600 font-medium py-2" data-id="element-143">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-gray-700 hover:text-purple-600 font-medium py-2" data-id="element-144">
              Services
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="block w-full text-left text-gray-700 hover:text-purple-600 font-medium py-2" data-id="element-145">
              How It Works
            </button>
            <button onClick={() => scrollToSection('pricing')} className="block w-full text-left text-gray-700 hover:text-purple-600 font-medium py-2" data-id="element-146">
              Pricing
            </button>
            <button onClick={() => scrollToSection('team')} className="block w-full text-left text-gray-700 hover:text-purple-600 font-medium py-2" data-id="element-147">
              Team
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-gray-700 hover:text-purple-600 font-medium py-2" data-id="element-148">
              Contact
            </button>
            <button onClick={() => scrollToSection('cta')} className="block w-full bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-2 rounded-full font-semibold mt-2" data-id="element-149">
              Get Started
            </button>
          </div>}
      </div>
    </nav>;
}